import { render, staticRenderFns } from "./place-header.vue?vue&type=template&id=474fb584"
import script from "./place-header.vue?vue&type=script&lang=js"
export * from "./place-header.vue?vue&type=script&lang=js"
import style0 from "./place-header.vue?vue&type=style&index=0&id=474fb584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports